import React from "react";
import "../index.scss";

interface ChatDrawerBodyProps {
  children: React.ReactNode;
  scrollRef?: any;
}

export const ChatDrawerBody: React.FC<ChatDrawerBodyProps> = ({ children, scrollRef }) => {
  return (
      <div
          ref={scrollRef}
          className="chat-drawer-body"
      >
        {children}
      </div>);
};